import { jsxs as _jsxs } from "preact/jsx-runtime";
export default function FinderStatus({ count, page, resultsRef }) {
    return (_jsxs("div", Object.assign({ 
        /*      aria-live="polite"
                          role="status"*/
        className: `finder-status has-h-2-font-size text-primary ${count === 0 ? 'finder-status--no-result' : ''}`, ref: resultsRef, tabIndex: -1 }, { children: [getStatusMessage(count), ' ', page > 1 && (_jsxs("span", { children: ["(", zankFinderStrings.paginationPage, " ", page, ")"] }, void 0))] }), void 0));
}
function getStatusMessage(count) {
    switch (count) {
        case 0:
            return zankFinderStrings.statusNoResult;
        case 1:
            return zankFinderStrings.statusOneResult;
        default:
            return `${count} ${zankFinderStrings.statusMultipleResults}`;
    }
}
